



















import Vue from 'vue'
import style from './style.module.scss'

import textInput from '../text-input/text-input.vue'

export default Vue.extend({
name: 'text-input-label',
  components: {
    textInput
  },
  props: {
    value: String,
    placeholder: String,
    error: Boolean,
    disabled: Boolean,
    autocomplete: String
  },
  data() {
    return {
      s: style
    }
  },
})
